import React, { useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { apiCall, removeParam, getBaseDir, getBranchNameFromId, moeda2float, disableForm, enableForm, float2moeda } from '../../utils.js';
import Swal from 'sweetalert2';
import TableBuilder from '../../table_builder.js';
import moment from 'moment-timezone';
const XLSX = require('xlsx');


const tableRef = new TableBuilder({
  table: '#table-installments-list',
  tableBody: '.js-installments-registrations-table',
  data: [],
  rowsPerPage: 25,
  filter: false,
  maxPages: 0,
  tableRowRenderer: function(rowData, opts) {
    return mountTableRow(rowData, opts);
  },
});

// Detecta alteração de página na tabela
$(document).on('click', `.js-pagination-page-${tableRef.getTableId()}`, function(e) {
  e.preventDefault();
  let pageId = $(this).text();
  tableRef.setCurrentPage(pageId); //console.log('pageId', pageId);
});
// Detecta alteração de página na tabela
$(document).on('click', `.js-pagination-previous-page-${tableRef.getTableId()}`, function(e) {
  e.preventDefault();
  let pageId = tableRef.getCurrentPage() - 1; //console.log('previous pageId', pageId);
  if (pageId <= 0)
      return;
  tableRef.setCurrentPage(pageId); //console.log('pageId', pageId);
});
// Detecta alteração de página na tabela
$(document).on('click', `.js-pagination-next-page-${tableRef.getTableId()}`, function(e) {
  e.preventDefault();
  let pageId = tableRef.getCurrentPage() + 1; //console.log('next pageId', pageId);
  if (pageId > tableRef.getMaxPages())
      return;
  tableRef.setCurrentPage(pageId); //console.log('pageId', pageId);
});

const mountTableRow = (rowData) => {
  /*let url = getBaseDir() + 'pacientes/cadastros?' + $.param({
    patient_id: rowData.CLIENTE_ID,
    branch: rowData.FILIAL
  });*/

  let receiptData = rowData.RECEBIMENTO_ID != null ? JSON.parse(rowData.RECEBIMENTOS) : null;

  return `
    <tr class="js-sale-view-installment-row" data-installment-id="${rowData.ID}" data-sale-id="${rowData.VENDA_ID}">
      <td><input type="checkbox" class="js-create-sale-item-checkbox" data-id="${rowData.ID}" /></td>
      <td data-label="Filial">${rowData.FILIAL}</td>
      <td data-label="Vencimento">${moment(rowData.DATA_VENCIMENTO).tz("America/Sao_Paulo").format('DD/MM/YYYY')}</td>
      <td data-label="Recebimento">${rowData.RECEBIMENTO_ID == null ? moment(rowData.DATA_VENCIMENTO).tz("America/Sao_Paulo").format('DD/MM/YYYY') : moment(receiptData.DATA_RECEBIMENTO).tz("America/Sao_Paulo").format('DD/MM/YYYY')}</td>
      <td data-label="Descrição">
        ${rowData.CLIENTE_NOME == null ? 
          `${rowData.OBS}`
          : 
          `Venda #${rowData.VENDA_ID} <br /> <small>${rowData.CATEGORIA} - ${rowData.CLIENTE_NOME}</small>`
        }
      </td>
      <td data-label="Valor (R$)">${float2moeda(rowData.VALOR_PARCELA)}</td>
      <td data-label="Situação">${renderInstallmentStatus(rowData.RECEBIMENTO_ID, rowData?.RECEBIMENTO_CONCILIADO ?? false)}</td>
      <td data-label="Ações">
        <!-- botão ações -->
        <div class="dropdown">
          <button class="btn btn-sm btn-secondary dropdown-toggle js-sale-actions-button" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Ações
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item js-sale-actions-button-edit" data-id="${rowData.ID}" href="#">Editar</a>
            <a class="dropdown-item d-none" href="#">Clonar</a>
            <a class="dropdown-item d-none" href="#">Imprimir</a>
            <a class="dropdown-item d-none" href="#">Excluir</a>
          </div>
        </div>
      </td>
    </tr>
  `
}

const renderInstallmentStatus = (status, conciliado) => {
  if (!conciliado) {
    switch (status) {
      case null: return '<div class="badge bg-warning">Em aberto</div>';
      case true: return '<div class="badge bg-success">Recebido</div>';
      case 'CONCILIADO': return '<div class="badge bg-success" data-tippy-content="Essa parcela possui um recebimento conciliado">Recebido <i class="fa fa-check-circle"></i></div>';
      default: return '<div class="badge bg-success">Recebido</div>';
    }
  } else {
    return '<div class="badge bg-success" data-tippy-content="Essa parcela possui um recebimento conciliado">Recebido <i class="fa fa-check-circle"></i></div>';
  }
}

const PatientsReports = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [branches, setBusinessBranches] = useState([]);
  const [formData, setFormData] = useState({
    branch: '',
    branchName: '',
    startDate: '',
    endDate: '',
    reportType: '',
    recordsPerPage: 25,
    page: 1
  })
  const interval = useRef(null);
  const searchQueryTimeout = useRef(null);
  const createSaleCustomerData = useRef(null);
  const createSaleFormData = useRef(null);
  const viewSale = useRef(false);
  const viewSaleData = useRef(false);
  const currentAcquirerersData = useRef(null);
  const currentInstallmentId = useRef(null);
  const currentAcquittanceId = useRef(null);

  const initData = () => {
    let userProfileResponse = { ...window._sessionData };
    setBusinessBranches(userProfileResponse.businessBranches);
    clearInterval(interval.current);
    fetchTableData();
    handleTableFilterChange();

    handleSaleCreateModal();
    handleSaleInstallmentAcquittance();
  }

  // Detecta alteração nos filtros da tabela
  const handleTableFilterChange = () => {
    $('.js-sales-registrations-branches-selector, .js-sales-registrations-start-date-input, .js-sales-registrations-end-date-input, .js-sales-per-page, #js-sales-registrations-search-input').on('change', function() {
      // debounce
      clearTimeout(searchQueryTimeout.current);
      searchQueryTimeout.current = setTimeout(function() {
        fetchTableData();
      }, 1000);
    });
  }

  // Busca os dados da tabela
  const fetchTableData = (pageId = false) => {
    let formData = {
        ...($('.js-financial-receivable-branches-selector').val() ? { branch: $('.js-financial-receivable-branches-selector').val() } : {}),
        ...($('.js-financial-receivable-start-date-input').val() ? { startDate: $('.js-financial-receivable-start-date-input').val() } : {}),
        ...($('.js-financial-receivable-end-date-input').val() ? { endDate: $('.js-financial-receivable-end-date-input').val() } : {}),
        ...($('.js-financial-receivable-per-page').val() ? { recordsPerPage: $('.js-financial-receivable-per-page').val() } : {}),
        ...($('#js-financial-receivable-search-input').val() ? { searchTerm: $('#js-financial-receivable-search-input').val() } : {})
    }
    if (pageId) {
      formData.page = pageId;
      setFormData(formData);
      window.localStorage.setItem('patientsReportsFormData', JSON.stringify(formData));
    }
    
    setIsLoading(true);

    apiCall({
      endpoint: 'api/v1/installments',
      method: 'GET',
      data: {
        ...formData
      },
      successCallback: (response) => {
        //console.log('response', response);

        /*setIsLoading(false);*/
        setFormData(formData);
        window.localStorage.setItem('financialReceivableFormData', JSON.stringify(formData));

        setTimeout(() => { tableRef.renderPage(tableRef.getCurrentPage(), false, response.data, false, response.total) }, 1000);
        
        setTimeout(() => {
          window.reloadIconss();
        }, 1500);
      },
      errorCallback: (err) => {
        setIsLoading(false);
        console.error('error', err);
      }
    });
  }

  // Detecta cliques no modal de criação de venda
  const handleSaleCreateModal = () => {

    // Detecta clique na linha da tabela de vendas no botão de ações para evitar propagação
    $(document).on('click', '.js-sale-actions-button', function(e) {
      e.stopPropagation();
    });

    // Detecta clique no botão de Ações de uma parcela
    $(document).on('click', '.js-sale-view-installment-details', function(e) {
      e.stopPropagation();
    });

    $('.js-view-sale-edit-mode').on('click', function(e) {
      console.log('click js-view-sale-edit-mode');
      let saleId = $(this).data('id');
      $('#modal-sale-create').addClass('child-modal');
      console.log('saleId', saleId);
      OnOpenSaleEditMode(e, saleId);
    });

    // Detecta clique no botão de criar nova venda
    $(document).on('click', '.js-sales-create-new,.js-sale-actions-button-edit', function(e) {
      currentInstallmentId.current = null;
      OnOpenInstallmentViewMode(currentInstallmentId.current);
    });

    // Detecta clique na linha de uma parcela (dentro modal de detalhes)
    $(document).on('click', '.js-sale-view-installment-row', function(e) {
      e.stopPropagation();
      console.log('view installment details', $(this).data('installment-id'))
      currentInstallmentId.current = $(this).data('installment-id');
      viewSale.current = $(this).data('sale-id');
      OnOpenInstallmentViewMode($(this).data('installment-id'));
    });

    // Detecta clique no botão de editar uma parcela (dentro modal de detalhes > ações)
    $(document).on('click', '.js-sale-view-installment-edit', function(e) {
      e.stopPropagation();
      console.log('edit installment', $(this).data('installment-id'))
    });

    // Detecta clique no botão de informar recebimento de uma parcela (dentro modal de detalhes > ações)
    $(document).on('click', '.js-sale-view-acquittance-edit,.js-sale-installment-acquittance', function(e) {
      e.stopPropagation();
      console.log('edit acquittance', $(this).data('installment-id'), $(this).data('acquittance-id'))
      OnOpenAcquittanceViewMode($(this).data('installment-id'), $(this).data('acquittance-id'));
    });

    // Detecta clique para desfazer conciliação bancária
    $(document).on('click', '.js-sale-undo-financial-conciliation', function(e) {
      e.stopPropagation();
      console.log('undo financial conciliation', $(this).data('installment-id'))

      let installmentId = $(this).data('installment-id');
      var currentBtn = $(this);
      currentBtn.prop('disabled', true);
      Swal.fire({
        title: 'Desfazer conciliação bancária',
        text: 'Tem certeza que deseja desfazer a conciliação bancária da parcela #' + installmentId + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, salvar',
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
      }).then((result) => {
        if (result.isConfirmed) {
          console.log('confirmed');
          apiCall({
            endpoint: 'api/v1/installments/' + installmentId + '/undo-financial-conciliation',
            method: 'POST',
            successCallback: (res) => {
              if (!res.error) {
                Swal.fire({
                  title: 'Conciliação bancária desfeita com sucesso!',
                  icon: 'success',
                  showConfirmButton: true
                });
                $('#modal-sale-installment-acquittance-edit').modal('hide');
                OnOpenInstallmentViewMode(installmentId);
                //if (currentAcquittanceId.current) {
                //  OnOpenAcquittanceViewMode(installmentId, currentAcquittanceId.current);
                //}
                fetchTableData();
              }
              currentBtn.prop('disabled', false);
            },
            errorCallback: function(err) {
              console.error('error', err);
              currentBtn.prop('disabled', false);
            }
          });
        } else {
          currentBtn.prop('disabled', false);
        }
      });
    });

    $('#modal-sale-installment-view').on('hidden.bs.modal', function() {
      $('.js-sale-installment-acquittance').removeClass('d-none');
    });

    $('#modal-sale-installment-acquittance-edit').on('hidden.bs.modal', function() {
      //currentInstallmentId.current = null;
      currentAcquittanceId.current = null;
    });
  }

  // Abre a modal de visualização de uma parcela
  const OnOpenInstallmentViewMode = (installmentId) => {
    console.log('OnOpenInstallmentViewMode viewSaleData.current', installmentId, viewSaleData.current);

    $('#modal-sale-installment-view').modal('show');

    apiCall({
      endpoint: 'api/v1/sale/' + viewSale.current,
      method: 'GET',
      successCallback: (res) => {
        console.log('res', res);

        if (res.error) {
          Swal.fire({
            title: 'Erro ao carregar informações da venda!',
            text: res.message,
            icon: 'error',
            showConfirmButton: true
          });
          $('#modal-sale-details').modal('hide');
        } else {
          viewSaleData.current = res.data;

          let parcela = viewSaleData.current.PARCELAS.filter((obj) => obj.ID == installmentId)?.[0] || {};
          console.log('OnOpenInstallmentViewMode parcela', parcela);

          $('.js-sale-installment-acquittance').attr('data-installment-id', parcela?.ID);
          $('.js-sale-installment-acquittance').attr('data-acquittance-id', parcela?.RECEBIMENTO_ID);

          $('#view-installment-branch').text(viewSaleData.current.FILIAL);
          $('#view-installment-customer').text(viewSaleData.current.CLIENTE_NOME);
          $('#view-installment-date').text(moment(viewSaleData.current.DATA_VENDA).tz('America/Sao_Paulo').format('DD/MM/YYYY'));
          $('#view-installment-due-date').text(moment(parcela.DATA_VENCIMENTO).tz('America/Sao_Paulo').format('DD/MM/YYYY'));

          $('#sale-installment-items-table-body').html(`
            <tr>
              <td>${moment(parcela.DATA_VENCIMENTO).tz('America/Sao_Paulo').format('DD/MM/YYYY')}</td>
              <td>${parcela.NOME ?? 'Outros'}</td>
              <td>${parcela.CONTA_BANCARIA_ID ?? 'Sem conta bancária'}</td>
              <td>${parcela.VALOR_PARCELA}</td>
              <td>${parcela?.RECEBIMENTO?.VALOR_JUROS ?? 0} / ${parcela?.RECEBIMENTO?.VALOR_MULTA ?? 0}</td>
              <td>${parcela?.RECEBIMENTO?.VALOR_DESCONTO ?? 0} / ${parcela?.RECEBIMENTO?.VALOR_TARIFA ?? 0}</td>
              <td>${renderInstallmentStatus(parcela?.RECEBIMENTO_ID, parcela?.RECEBIMENTO_CONCILIADO ?? false)}</td>
              <td>
                <div class="dropdown">
                  <button class="btn btn-sm btn-secondary dropdown-toggle js-sale-view-installment-details" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Ações
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    ${parcela.RECEBIMENTO_ID !== null ? `<a class="dropdown-item js-sale-view-acquittance-edit" data-installment-id="${parcela.ID}" data-acquittance-id="${parcela.RECEBIMENTO_ID}" href="#">Editar recebimento</a>` : `<a class="dropdown-item js-sale-view-acquittance-edit" data-installment-id="${parcela.ID}" href="#">Informar recebimento</a>`}
                    ${parcela?.RECEBIMENTO_CONCILIADO ? `<a class="dropdown-item js-sale-undo-financial-conciliation" data-installment-id="${parcela.ID}" href="#">Desfazer conciliação</a>` : ''}
                    <a class="dropdown-item d-none" href="#">Imprimir</a>
                    <a class="dropdown-item d-none" href="#">Excluir</a>
                  </div>
                </div>
              </td>
            </tr>
          `);

          if (parcela?.RECEBIMENTO_ID !== null || parcela?.RECEBIMENTO_CONCILIADO !== null) {
            $('.js-sale-installment-acquittance').addClass('d-none');
          } else {
            $('.js-sale-installment-acquittance').removeClass('d-none');
          }
        }
      },
      errorCallback: (err) => {
        console.error('error', err);
      }
    });
  }

  // Abre a modal de quitação de uma parcela
  const OnOpenAcquittanceViewMode = (installmentId, acquittanceId) => {
    console.log('OnOpenAcquittanceViewMode', installmentId, acquittanceId);

    currentInstallmentId.current = installmentId;
    currentAcquittanceId.current = acquittanceId;

    let parcela = viewSaleData.current.PARCELAS.filter((obj) => obj.ID == installmentId)?.[0] || {};
    console.log('OnOpenAcquittanceViewMode parcela', parcela);

    $('input[name="sale-acquittance-installment-value"]').val(float2moeda(parcela.VALOR_PARCELA));
    $('input[name="sale-acquittance-date"]').val(moment(parcela.DATA_VENCIMENTO).tz('America/Sao_Paulo').format('YYYY-MM-DD'));

    $('#sale-acquittance-payment-method').html(`<option value='${parcela.FORMA_PAGAMENTO_ID}' selected>${parcela.NOME}</option>`);
    $('#sale-acquittance-payment-method').val(parcela.FORMA_PAGAMENTO_ID).trigger('select2:select');

    window.reloadMasks();

    if (parcela.RECEBIMENTO_ID !== null || parcela.RECEBIMENTO_CONCILIADO) {
      //alert('a');
      $('#sale-acquittance-amount').val(float2moeda(parcela.RECEBIMENTO.VALOR_RECEBIDO));
      $('#sale-acquittance-fine').val(float2moeda(parcela.RECEBIMENTO.VALOR_MULTA));
      $('#sale-acquittance-interest').val(float2moeda(parcela.RECEBIMENTO.VALOR_JUROS));
      $('#sale-acquittance-discount').val(float2moeda(parcela.RECEBIMENTO.VALOR_DESCONTO));
      $('#sale-acquittance-fee').val(float2moeda(parcela.RECEBIMENTO.VALOR_TARIFA));
      $('#sale-acquittance-condition').val(parcela.OBS);

      $('#modalSaleViewAcquittanceToggleLabel').html('Editar recebimento');
      //$('.js-sale-installment-acquittance-back-to-open').removeClass('d-none');
      //$('#save-create-installment-acquittance').text('Salvar');

      if (parcela?.RECEBIMENTO_ID || parcela?.RECEBIMENTO_CONCILIADO) {
        if (parcela?.RECEBIMENTO_CONCILIADO !== null) {
          $('.js-sale-installment-acquittance-alert-container').removeClass('d-none');
          $('.js-sale-installment-acquittance-alert-container').html(`
            <div class="alert alert-info" role="alert">
              <strong>Atenção!</strong> A parcela #${installmentId} já foi recebida e conciliada. Para editar o recebimento, clique em "Desfazer conciliação".
              <br />
              <a href="#" class="btn btn-sm btn-secondary js-sale-undo-financial-conciliation" data-installment-id="${installmentId}">Desfazer conciliação</a>
            </div>
          `);
          $('.js-sale-installment-acquittance-back-to-open').addClass('d-none');
        } else {
          $('.js-sale-installment-acquittance-back-to-open').removeClass('d-none');
        }
        $('#save-create-installment-acquittance').addClass('d-none');
      } else {
        $('.js-sale-installment-acquittance-alert-container').addClass('d-none');
        $('.js-sale-installment-acquittance-back-to-open').removeClass('d-none');
        $('#save-create-installment-acquittance').removeClass('d-none');
        $('#save-create-installment-acquittance').text('Salvar');
      }

      //disableForm('.js-sale-installment-acquittance-modal-body');
    } else {
      //alert('b');
      $('#sale-acquittance-amount').val('');
      $('#sale-acquittance-fine').val('');
      $('#sale-acquittance-interest').val('');
      $('#sale-acquittance-discount').val('');
      $('#sale-acquittance-fee').val('');
      //$('#sale-acquittance-condition').val('');

       $('.js-sale-installment-acquittance-alert-container').html(``);
      $('.js-sale-installment-acquittance-alert-container').addClass('d-none');
      $('#modalSaleViewAcquittanceToggleLabel').html('Informar recebimento');
      $('.js-sale-installment-acquittance-back-to-open').addClass('d-none');
      $('#save-create-installment-acquittance').text('Confirmar recebimento');
      $('#save-create-installment-acquittance').removeClass('d-none');

      //enableForm('.js-sale-installment-acquittance-modal-body');
    }

    $('#modal-sale-installment-acquittance-edit').modal('show');
  }

  // Detecta alterações no formulário de quitação de uma parcela
  const handleSaleInstallmentAcquittance = () => {
    $('#sale-acquittance-payment-method').select2({
      placeholder: "Selecione o método",
      theme: 'bootstrap-5',
      dropdownParent: $(`.js-sale-acquittance-payment-method-container`),
      minimumInputLength: 3,
      ajax: {
        url: getBaseDir() + 'api/v1/sale/payment-methods',
        delay: 1000,
        data: function(params) {
          var query = {
            search: params.term,
            page: params.page || 1
          }
          return query;
        },
        processResults: function(data, params) {
          params.page = params.page || 1;

          var results = [];
          $.each(data.data, function(k, v) {
            results.push({
              id: v.ID,
              text: v.NOME,
              info: v
            });
          });

          return {
            results: results,
            pagination: {
              more: (params.page * 10) < data.count_filtered
            }
          };
        }
      }
    });

    $('#sale-acquittance-payment-method').on('select2:select', function(e) {
      let parcela = viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)?.[0] || {};
      console.log('parcela', parcela);
      let hadNoParams = !e.params;
      if (!e.params) {
        e.params = {
          data: {
            id: parcela.FORMA_PAGAMENTO_ID,
            info: parcela
          }
        }
      } else {
        parcela.FORMA_PAGAMENTO_ID = e.params.data.info.ID;
        viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)[0] = parcela;
      }
      
      if (e.params.data.info.MAX_PARCELAS != null) {
        let html = `<option value="" disabled>Selecione a condição</option>`;
        for (let j = 1; j <= e.params.data.info.MAX_PARCELAS; j++) {
          html += `<option value="${j}" ${parcela.OBS == j ? 'selected' : ''}>${j}x</option>`;
        }
        $(`#sale-acquittance-condition`).html(html);

        apiCall({
          endpoint: 'api/v1/sale/payment-methods/acquirers',
          method: 'GET',
          data: {
            paymentMethodId: hadNoParams ? parcela.FORMA_PAGAMENTO_ID : e.params.data.info.ID,
            acquirerIds: e.params.data.info.ADQUIRENTES_IDS
          },
          successCallback: (response) => {
            currentAcquirerersData.current = response.data;
            let html = `<option value="" selected disabled>Selecione o adquirente</option>`;
            $.each(response.data, function(k, v) {
              html += `<option value="${v.ID}" data-info='${JSON.stringify(v)}' ${parcela.ADQUIRENTE_ID == v.ID ? 'selected' : ''}>${v.NOME}</option>`;
            });
            $(`#sale-acquittance-acquirer`).html(html);


            if (parcela.ADQUIRENTE_ID != null && parcela.BANDEIRA_ID != null) {
              let adquirenteData = currentAcquirerersData.current.find(item => item.ID == parcela.ADQUIRENTE_ID);
              if (adquirenteData.BANDEIRAS.length > 0) {
                let html = `<option value="" selected disabled>Selecione a bandeira</option>`;
                $.each(adquirenteData.BANDEIRAS, function(k, v) {
                  html += `<option value="${v.ID}" ${parcela.BANDEIRA_ID == v.ID ? 'selected' : ''}>${v.BANDEIRA}</option>`;
                });
                $(`#sale-acquittance-bandeira`).html(html);
              } else {
                $(`#sale-acquittance-bandeira`).html('<option value="" selected disabled>Sem bandeira</option>');
              }
            }
          },
          errorCallback: (err) => {
            console.error('error', err);
          }
        });
      } else {
        currentAcquirerersData.current = [];
        viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)[0].ADQUIRENTE_ID = null;
        viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)[0].BANDEIRA_ID = null;
        viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)[0].OBS = 1;
        $(`#sale-acquittance-acquirer`).html('<option value="" selected disabled>Sem adquirente</option>');
        $(`#sale-acquittance-bandeira`).html('<option value="" selected disabled>Sem bandeira</option>');
        $(`#sale-acquittance-condition`).html(`
          <option value="1" selected disabled>À vista</option>
        `);
      }

      if (e.params.data.info.CONTAS_BANCARIAS != null) {
        if (e.params.data.info.CONTAS_BANCARIAS.length > 0) {
          let html = `<option value="" selected disabled>Selecione a conta bancária</option>`;
          $.each(e.params.data.info.CONTAS_BANCARIAS, function(k, v) {
            html += `<option value="${v.ID}" ${parcela.CONTA_BANCARIA_ID == v.ID ? 'selected' : ''} data-is-bank="1">${v.CONTA}</option>`;
          });
          setTimeout(() => {
            $(`#sale-acquittance-acquirer`).html(html);
          }, 1000);
        }
      }
    });

    $(document).on('change', '#sale-acquittance-acquirer', function() {
      let parcela = viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)?.[0] || {};
      let isBank = $(this).find('option:selected').data('is-bank');
      if (isBank == 1) {
        parcela.CONTA_BANCARIA_ID = $(this).val();
      } else {
        parcela.ADQUIRENTE_ID = $(this).val();
      }
      viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)[0] = parcela;

      if (parcela.ADQUIRENTE_ID != null) {
        let adquirenteData = currentAcquirerersData.current.find(item => item.ID == parcela.ADQUIRENTE_ID);
        if (adquirenteData?.BANDEIRAS?.length > 0) {
          let html = `<option value="" selected disabled>Selecione a bandeira</option>`;
          $.each(adquirenteData.BANDEIRAS, function(k, v) {
            html += `<option value="${v.ID}" ${parcela.BANDEIRA_ID == v.ID ? 'selected' : ''}>${v.BANDEIRA}</option>`;
          });
          $(`#sale-acquittance-bandeira`).html(html);
        } else {
          $(`#sale-acquittance-bandeira`).html('<option value="" selected disabled>Sem bandeira</option>');
        }
      }
    });

    $(document).on('change', '#sale-acquittance-bandeira', function() {
      let parcela = viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)?.[0] || {};
      parcela.BANDEIRA_ID = $(this).val();
      viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)[0] = parcela;
    });

    $(document).on('change', '#sale-acquittance-condition', function() {
      let parcela = viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)?.[0] || {};
      parcela.OBS = $(this).val();
      viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)[0] = parcela;
    });

    $(document).on('click', '#save-create-installment-acquittance', function() {
      var parcela = viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)?.[0] || {};
      disableForm('.js-sale-installment-acquittance-modal-container');
      Swal.fire({
        title: 'Tem certeza que deseja salvar?',
        text: 'Você está prestes a salvar a quitação da parcela ' + parcela.NOME + ' da venda ' + viewSaleData.current.ID,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, salvar',
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33'
      }).then((result) => {
        if (result.isConfirmed) {
          let parcelaData = {
            ID: parcela.ID,
            FORMA_PAGAMENTO_ID: parcela.FORMA_PAGAMENTO_ID,
            ADQUIRENTE_ID: parcela.ADQUIRENTE_ID,
            BANDEIRA_ID: parcela.BANDEIRA_ID,
            OBS: parcela.OBS,
            CONTA_BANCARIA_ID: parcela.CONTA_BANCARIA_ID,
            RECEBIMENTO: {
              ...(parcela.RECEBIMENTO_ID != null ? {
                ID: parcela.RECEBIMENTO_ID
              } : {}),
              DATA_RECEBIMENTO: $('#sale-acquittance-date').val(),
              VALOR_RECEBIDO: moeda2float($('#sale-acquittance-amount').val()),
              VALOR_MULTA: moeda2float($('#sale-acquittance-fine').val()),
              VALOR_JUROS: moeda2float($('#sale-acquittance-interest').val()),
              VALOR_DESCONTO: moeda2float($('#sale-acquittance-discount').val()),
              VALOR_TARIFA: moeda2float($('#sale-acquittance-fee').val())
            }
          }

          apiCall({
            endpoint: 'api/v1/sale/installments/acquittances',
            method: 'POST',
            data: parcelaData,
            successCallback: (response) => {
              console.log('res', response);
              window.toast({
                success: response.error,
                text: response.message
              });

              if (!response.error) {
                //currentInstallmentId.current = null;
                $('#modal-sale-installment-acquittance-edit').modal('hide');
                OnOpenInstallmentViewMode(currentInstallmentId.current);
                //if (currentAcquittanceId.current) {
                  //OnOpenAcquittanceViewMode(currentInstallmentId.current, currentAcquittanceId.current);
                //}
                fetchTableData();
              }

              enableForm('.js-sale-installment-acquittance-modal-container');
            },
            errorCallback: (err) => {
              enableForm('.js-sale-installment-acquittance-modal-container');
              console.error('error', err);
            }
          });
        } else {
          enableForm('.js-sale-installment-acquittance-modal-container');
        }
      });
    });

    $(document).on('click', '.js-sale-installment-acquittance-back-to-open', function() {
      var parcela = viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)?.[0] || {};
      disableForm('.js-sale-installment-acquittance-modal-container');
      Swal.fire({
        title: 'Tem certeza que deseja voltar para Em Aberto?',
        text: 'Você está prestes a voltar a parcela para Em Aberto',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, voltar',
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33'
      }).then((result) => {
        if (result.isConfirmed) {
          apiCall({
            endpoint: 'api/v1/sale/installments/acquittances',
            method: 'DELETE',
            data: {
              ID: parcela.RECEBIMENTO.ID
            },
            successCallback: (response) => {
              window.toast({
                success: response.error,
                text: response.message
              });

              if (!response.error) {
                //currentInstallmentId.current = null;
                $('#modal-sale-installment-acquittance-edit').modal('hide');
                OnOpenInstallmentViewMode(currentInstallmentId.current);
                //if (currentAcquittanceId.current) {
                //  OnOpenAcquittanceViewMode(currentInstallmentId.current, currentAcquittanceId.current);
                //}
                fetchTableData();
              }

              enableForm('.js-sale-installment-acquittance-modal-container');
            },
            errorCallback: (err) => {
              enableForm('.js-sale-installment-acquittance-modal-container');
              console.error('error', err);
            }
          });
        } else {
          enableForm('.js-sale-installment-acquittance-modal-container');
        }
      });
    });
  }

  React.useEffect(() => {
    interval.current = setInterval(() => {
      if (window._sessionData.businessBranches && branches.length === 0) {
        initData();
      }
    }, 1000);

    tableRef.setFetchTableData(fetchTableData);
  }, []);

  React.useEffect(() => {
    //console.log('createSaleFormData', createSaleFormData.current);
  }, [createSaleFormData]);

  React.useEffect(() => {
    //console.log('createSaleCustomerData', createSaleCustomerData.current);
  }, [createSaleCustomerData]);

  return (
    <>
     <div className="col-12 p-2">
        <table id="table-installments-list" class="align-middle mb-0 table table-borderless table-striped table-hover responsive-table">
          <thead>
            <tr>
              <th class="text-center"></th>
              <th data-label="Filial">Filial</th>
              <th data-label="Vencimento">Vencimento</th>
              <th data-label="Recebimento">Recebimento</th>
              <th data-label="Descrição">Descrição</th>
              <th data-label="Total (R$)">Total (R$)</th>
              <th data-label="Situação">Situação</th>
              <th data-label="Ações">Ações</th>
            </tr>
          </thead>
          <tbody class="js-installments-registrations-table">
            <tr>
              <td class="text-center" colspan="9">Carregando....</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

try {
  if (document.getElementById('js-financial-receivable-container')) {
    const container = document.getElementById('js-financial-receivable-container');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<PatientsReports />);
  }
} catch(err) {
  console.error('PatientsReports error', err);
}